import { render, staticRenderFns } from "./Typography.vue?vue&type=template&id=0887ed2a&scoped=true"
import script from "./Typography.vue?vue&type=script&lang=js"
export * from "./Typography.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0887ed2a",
  null
  
)

export default component.exports